<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: "SubInEdit",
    beforeCreate() {
      this.$store.dispatch('subscriptions/initSubscriptions');
    },

    mounted() {
      this.populateSubInEditById({ subId: this.$route.params.subId });
    },

    computed: {
      ...mapState('subscriptions', [
        'subs',
        'subInEdit'
      ])
    },

    methods: {
      ...mapActions('subscriptions', [
        'populateSubInEditById'
      ])
    },

    watch: {
      subs() {
        this.populateSubInEditById({ subId: this.$route.params.subId });
      }
    }
  };
</script>
